"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var webcam_component_1 = require("./webcam.component");
exports.WebCamComponent = webcam_component_1.WebCamComponent;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ack-angular-webcam/index.js
// module id = 942
// module chunks = 4